<div class="slider slider__moods" #tagsSlider *ngIf="tags.length > 0">
  <div class="slider__item" *ngFor="let tag of tags;  let i = index">
    <a routerLink="/genres" [queryParams]="{id: tag.id}" class="mood" [ngClass]="getClassForTag(i, tag)">{{tag.title}}<i [ngClass]="getIconClass(tag)"></i></a>
  </div>
</div>
